

























































import {Component, Vue, Watch, Emit} from 'vue-property-decorator';
import SimpleDialog from '@c/SimpleDialog.vue';
import userStoreModule from '@/store/modules/entities/userModule';

@Component({components: {SimpleDialog}})
export default class ReportUploadButton extends Vue {
  // Диалоговое окно для выгрузки отчета
  reportDialog = false;

  // Диалоговое окно аутентификации в аккаунте гугл
  googleDialog = false;

  // tooltip
  menuHelp = false;

  // Код полученный от google
  code = '';

  // Статус кнопки "подтверждения" в диалоговом окне аутентификации
  statusGoogleDialogButton = false;

  // Имя файла отчета
  reportName = '';

  // Статус кнопки "подтверждения" в диалоговом окне ввода наименования отчета
  statusReportDialogButton = false;

  // Получаем ссылку для привязки гугл-аккаунта
  async startFlow() {
    const response = await userStoreModule.startFlow();
    if (response.status === 'ok') window.open(response.authorize_link, '_blank');
    // TODO: вывод ошибки сделать?
  }

  @Watch('code')
  onChangedCode(newVal: string) {
    if (newVal) this.statusGoogleDialogButton = true;
  }

  // Отправляем полученный от google код на сервер для привязки аккаунта
  async submitCode() {
    const response = await userStoreModule.submitCode(this.code);
    if (response) this.reportDialog = true;
  }

  @Watch('reportName')
  onChangedReportName(newVal: string) {
    if (newVal) this.statusReportDialogButton = true;
  }

  // Отправляем запрос на формирование отчета на сервер и открываем google-документы в новой вкладке
  @Emit('getFileName')
  exportReport() {
    return {reportFileName: this.reportName, keyFilename: userStoreModule.getGoogleAuth};
  }

  doReport() {
    const googleAuth = userStoreModule.getGoogleAuth;
    if (googleAuth) this.reportDialog = true;
    else this.googleDialog = true;
  }
}
